import {
  doc,
  addDoc,
  setDoc,
  getDocs,
  deleteDoc,
  collection,
} from "firebase/firestore";

import { db } from "configs";
import { Iterable } from "types";
import { castDocs } from "utils/helpers";

export const list = async <T>(collectionName: string) => {
  try {
    const response = await getDocs(collection(db, collectionName));
    const documents = castDocs<Iterable<T>>(response);
    return Promise.resolve(documents);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createDoc = (collectionName: string, data: any) => {
  const collectionRef = collection(db, collectionName);
  return addDoc(collectionRef, data);
};

export const editDoc = (collectionName: string, id: string, data: any) => {
  const docRef = doc(db, collectionName, id);
  return setDoc(docRef, data);
};

export const removeDoc = (collectionName: string, id: string) => {
  const docRef = doc(db, collectionName, id);
  return deleteDoc(docRef);
};
